export default "__VITE_ASSET__Crl9iELp__"